import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ObjectFieldTemplate(props) {
  var TitleField = props.TitleField,
    DescriptionField = props.DescriptionField;
  var image = props.uiSchema['ui:image'];
  var ABOVE = props.uiSchema['ui:imagePosition'] == 'ABOVE' || props.uiSchema['ui:imagePosition'] !== 'BELOW';
  var BELOW = props.uiSchema['ui:imagePosition'] == 'BELOW';
  var imageElement = /*#__PURE__*/_jsx("div", {
    className: "text-center",
    children: /*#__PURE__*/_jsx("div", {
      className: "img-thumbnail",
      children: /*#__PURE__*/_jsx("img", {
        src: image,
        className: "img-responsive"
      })
    })
  });
  return /*#__PURE__*/_jsxs("fieldset", {
    children: [image && ABOVE && imageElement, (props.uiSchema['ui:title'] || props.title) && /*#__PURE__*/_jsx(TitleField, {
      id: "".concat(props.idSchema.$id, "__title"),
      title: props.title || props.uiSchema['ui:title'],
      required: props.required,
      formContext: props.formContext
    }), props.description && /*#__PURE__*/_jsx(DescriptionField, {
      id: "".concat(props.idSchema.$id, "__description"),
      description: props.description,
      formContext: props.formContext
    }), props.properties.map(function (prop) {
      return prop.content;
    }), image && BELOW && imageElement]
  });
}
export default ObjectFieldTemplate;
//# sourceMappingURL=ObjectFieldTemplate.js.map